import React from 'react';
import SocietyPage from '../Components/SocietyData/SocietyPage';
import { Navbar,Footer } from '../Components/Home/layout';
const SocietycataloguePage = () => {
    return(
        <>
            <Navbar/>
              <SocietyPage/>
              <Footer/>
        </>      
    )
}

export default SocietycataloguePage ;